import React, { Component, Fragment } from 'react';
import { createPortal } from 'react-dom';
import { Input, Select, Tabs, Checkbox } from 'antd';
import Panel from '../Panel';
import { getPanelMaxHeight, getPanelMaxWidth, getPanelWidth } from '../../services/helper/panelSizeHelper';
import '@/publicCss/style.css';
import '@/publicCss/tree.css';
import '@/publicCss/aurora.css';
import './index.css';
import { ROUGHNESS_MODE_LIST } from '../../services/Sierra/prelayout/Schematic';
import { PreLayoutRoughness, ROUGHNESS_HEIGH, ROUGHNESS_RMS, ROUGHNESS_RMS_CHILDREN, ROUGHNESS_RS_MATRIX_CHILDREN, ROUGHNESS_SCALE_RS_MATRIX, SCALE_RS } from '../../services/Sierra/prelayout/Schematic/constants';
import { splitValueUnitByUnits } from '../../services/helper/numberHelper';
import UnitAddonAfter from '../UnitAddonAfter';
import { numberCheck } from '../../services/helper/dataProcess';
import { METAL } from '../../services/Stackup';
import "./index.css";

const ROUGHNESS_HEIGHT_UNITS = ["mm", "um", "nm", "pm"], ROUGHNESS_HEIGHT_UNIT = "heightUnit";
class RoughnessPanel extends Component {

  constructor(props) {
    super(props);
    const { roughnessList, roughnessInput } = this.initRoughness();
    const { record } = props;

    this.state = {
      errorMsg: null,
      maxHeight: 1000,
      maxWidth: 1000,
      roughnessList,
      roughnessInput,
      tabKey: record.name,
      applyAll: true
    }

    this.dialogRoot = document.getElementById('root');
  }

  initRoughness = () => {
    const { record, config } = this.props;
    let currRoughness = {};
    const layers = config.layers || [];
    let roughnessList = layers.filter(item => item.type === METAL).map(item => {
      const roughness = { ...(item.roughness || { mode: "None" }) }
      if (item.name === record.name) {
        currRoughness = { ...roughness }
      }
      return { name: item.name, roughness }
    });

    if (currRoughness && currRoughness.mode === ROUGHNESS_RMS) {
      const { value, unit } = splitValueUnitByUnits(currRoughness[ROUGHNESS_HEIGH] || "", ROUGHNESS_HEIGHT_UNITS)
      currRoughness[ROUGHNESS_HEIGH] = value;
      currRoughness[ROUGHNESS_HEIGHT_UNIT] = unit;
    }

    const roughnessInput = this.getRoughnessInputData(currRoughness);
    return { roughnessList, roughnessInput }
  }

  closeModal = () => {
    const { errorMsg, roughnessList } = this.state;
    if (errorMsg) {
      return;
    }

    this.props.saveRoughness(roughnessList)
    this.props.save();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxHeight: getPanelMaxHeight(offset, 1000) - 50,
      maxWidth: getPanelMaxWidth(offset, 1000)
    })
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.resize);
  }

  componentDidUpdate = (prevProps) => {
    const { record } = this.props;
    const { name } = record || {};
    const { name: prevName } = prevProps.record || {}
    if (prevName && name !== prevName) {
      this.getDefaultData()
    }
  }

  getDefaultData = () => {
    const { roughnessList, roughnessInput } = this.initRoughness();
    this.setState({
      roughnessList,
      roughnessInput
    })
  }

  getRoughnessInputData = (roughness) => {
    return {
      ...roughness,
      [SCALE_RS]: roughness[SCALE_RS] || "",
      [ROUGHNESS_HEIGH]: roughness[ROUGHNESS_HEIGH],
      [ROUGHNESS_HEIGHT_UNIT]: roughness[ROUGHNESS_HEIGHT_UNIT] || "um"
    }
  }

  updateErrorMsg = (errorMsg) => {
    this.setState({
      errorMsg
    })
  }

  selectMode = (value) => {
    const { roughnessList } = this.state;
    let _roughnessList = [...roughnessList];
    const roughness = { ...new PreLayoutRoughness({ mode: value }) };
    for (let item of _roughnessList) {
      item.roughness = { ...roughness };
    }

    if (roughness.mode === ROUGHNESS_RMS) {
      const { value, unit } = splitValueUnitByUnits(roughness[ROUGHNESS_HEIGH] || "", ROUGHNESS_HEIGHT_UNITS)
      roughness[ROUGHNESS_HEIGH] = value;
      roughness[ROUGHNESS_HEIGHT_UNIT] = unit;
    }
    this.setState({
      roughnessList: _roughnessList,
      roughnessInput: this.getRoughnessInputData(roughness),
      errorMsg: null
    })
  }

  selectChange = (value, type) => {
    const { roughnessList, roughnessInput } = this.state;
    let _roughnessInput = { ...roughnessInput }, _roughnessList = [...roughnessList];
    _roughnessInput[type] = value;
    for (let item of _roughnessList) {
      item.roughness[type] = value;
    }
    this.setState({
      roughnessList: _roughnessList,
      roughnessInput: _roughnessInput
    })
  }

  changeChecked = (e, type) => {
    const checked = e.target.checked;
    this.setState({
      [type]: e.target.checked
    })

    if (!checked) {
      return;
    }
    const { roughnessInput, roughnessList } = this.state;
    let _roughnessList = [...roughnessList];

    for (let item of _roughnessList) {
      if (item.roughness.mode === ROUGHNESS_RMS) {
        item.roughness[ROUGHNESS_HEIGH] = `${roughnessInput[ROUGHNESS_HEIGH]}${roughnessInput[ROUGHNESS_HEIGHT_UNIT]}`;
      } else if (item.roughness.mode === ROUGHNESS_SCALE_RS_MATRIX) {
        item.roughness[SCALE_RS] = roughnessInput[SCALE_RS];
      }
    }
    this.setState({
      roughnessList: _roughnessList
    })
  }

  inputUnitRender = (key, unitKey) => {
    const { roughnessInput } = this.state;
    return UnitAddonAfter({
      unit: roughnessInput[unitKey],
      changeUnit: (value) => this.changeUnit(value, unitKey),
      list: ROUGHNESS_HEIGHT_UNITS,
      defaultUnit: "um"
    })
  }

  changeUnit = (unit, unitKey) => {
    const { roughnessInput, roughnessList, applyAll } = this.state;
    let _roughnessList = [...roughnessList];

    for (let item of _roughnessList) {
      if (!applyAll && item.name !== roughnessInput.name) {
        continue;
      }
      item.roughness[ROUGHNESS_HEIGH] = `${roughnessInput[ROUGHNESS_HEIGH]}${unit}`;
    }
    this.setState({
      roughnessInput: { ...roughnessInput, [unitKey]: unit },
      roughnessList: _roughnessList
    })
  }

  inputChange = (e, type) => {
    const value = e.target.value;
    const { errorMsg } = this.state;
    errorMsg && errorMsg.type === type && this.updateErrorMsg(null)
    this.setState({
      roughnessInput: { ...(this.state.roughnessInput || {}), [type]: value }
    })
  }

  inputBlur = (e, type) => {
    const value = e.target.value;
    let error = numberCheck(value, true);
    if (!error && parseFloat(value) <= 0) {
      error = `Value must be greater than 0.`;
    }
    if (error) {
      this.updateErrorMsg({ type, msg: error })
      return
    }

    const { roughnessInput, roughnessList, applyAll } = this.state;
    let _roughnessList = [...roughnessList];
    for (let item of _roughnessList) {
      if (!applyAll && item.name !== roughnessInput.name) {
        continue;
      }
      if (type === ROUGHNESS_HEIGH) {
        item.roughness[ROUGHNESS_HEIGH] = `${value}${roughnessInput[ROUGHNESS_HEIGHT_UNIT]}`;
      } else {
        item.roughness[type] = value;
      }
    }

    this.setState({
      roughnessInput: { ...roughnessInput, [type]: value },
      roughnessList: _roughnessList
    })
  }

  onKeyDown = (e, type) => {
    if (e.keyCode === 188) {
      this.inputBlur(e, type);
    }
  }

  changeTabKey = (key) => {
    const { roughnessInput, roughnessList, tabKey } = this.state;
    let _roughnessList = [...roughnessList]
    //save pre tab roughness data
    const index = _roughnessList.findIndex(item => item.name === tabKey);
    _roughnessList[index].roughness = new PreLayoutRoughness({
      mode: roughnessInput.mode,
      scaleRS: roughnessInput.scaleRS,
      method: roughnessInput.method,
      height: roughnessInput.height ? `${roughnessInput.height}${roughnessInput[ROUGHNESS_HEIGHT_UNIT]}` : "",
    });
    //get new tab roughness data
    const findItem = _roughnessList.find(item => item.name === key);
    const currRoughness = { ...findItem.roughness };

    const { value, unit } = splitValueUnitByUnits(currRoughness[ROUGHNESS_HEIGH] || "", ROUGHNESS_HEIGHT_UNITS)
    currRoughness[ROUGHNESS_HEIGH] = value;
    currRoughness[ROUGHNESS_HEIGHT_UNIT] = unit;

    const _roughnessInput = this.getRoughnessInputData(currRoughness);
    this.setState({
      tabKey: key,
      roughnessList: _roughnessList,
      roughnessInput: _roughnessInput
    })
  }

  renderDialog = () => {
    const { record, product } = this.props;
    const { name } = record || {};
    const { errorMsg, maxHeight, maxWidth, roughnessInput } = this.state;
    const content = (
      <Panel
        className={`aurora-pre-layout-roughness-panel ${product}-panel`}
        position='panel-center-top'
        title={`${name} - Surface Roughness`}
        zIndex={2000}
        onCancel={() => { this.closeModal() }}
        width={getPanelWidth(maxWidth, { defaultWidth: 400 })}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        draggable
        minHeight={200}
        overflow={"auto"}
      >
        <div className='pre-layout-roughness-content'>
          <div className='library-item'>
            <label>Mode</label>
            <Select
              className="aurora-select"
              popupClassName="aurora-select-dropdown"
              onSelect={(value) => this.selectMode(value)}
              value={roughnessInput.mode}
              size='small'
              options={ROUGHNESS_MODE_LIST.map(item => ({ value: item.key, label: item.title }))}
            />
          </div>
          {this.getContent()}
          {errorMsg && errorMsg.msg && <span className='model-name-error-msg'>{errorMsg.msg}</span>}
        </div>
      </Panel>
    )
    return createPortal(content, this.dialogRoot)
  }

  getContent = () => {
    const { roughnessInput, tabKey, roughnessList } = this.state;
    if (roughnessInput.mode === "None") {
      return;
    }
    const children = roughnessInput.mode === ROUGHNESS_RMS ? ROUGHNESS_RMS_CHILDREN : ROUGHNESS_RS_MATRIX_CHILDREN;
    if (roughnessInput.mode === ROUGHNESS_RMS) {
      return <Fragment>
        {this.itemContent([children[0]])}
        <Tabs
          activeKey={tabKey}
          type="card"
          size="small"
          onChange={this.changeTabKey}
          items={roughnessList.map((item) => {
            return {
              label: item.name,
              key: item.name,
              children: this.itemContent([children[1], {
                key: "applyAll",
                title: "Apply to all metal layers",
                type: "checkbox"
              }]),
            };
          })}
        />
        {this.itemContent([{
          key: "text",
          title: "All metal layers share this mode",
          type: "text"
        }])}
      </Fragment>
    }
    return this.itemContent([...children, {
      key: "text",
      title: "All metal layers share this mode",
      type: "text"
    }]);
  }

  itemContent = (children) => {
    const { roughnessInput } = this.state;

    return children.map(item => {
      return <div className='library-item' key={item.key}>
        {item.type === "checkbox" ?
          <Checkbox
            checked={this.state[item.key]}
            onChange={(e) => this.changeChecked(e, item.key)}
          >{item.title}</Checkbox>
          : item.type === "text" ?
            <div className='library-item-text'>{item.title}</div>
            : <Fragment>
              <label>{item.title}</label>
              {item.type === "select" ? <Select
                className="aurora-select"
                popupClassName="aurora-select-dropdown"
                onSelect={(value) => this.selectChange(value, item.key)}
                value={roughnessInput[item.key]}
                size='small'
                options={item.options.map(item => ({ value: item, title: item }))}
              />
                : <Input
                  className='aurora-input'
                  value={roughnessInput[item.key]}
                  onChange={(e) => this.inputChange(e, item.key)}
                  onPressEnter={(e) => this.inputBlur(e, item.key)}
                  onBlur={(e) => this.inputBlur(e, item.key)}
                  onKeyDown={(e) => this.onKeyDown(e, item.key)}
                  addonAfter={item.key === ROUGHNESS_HEIGH ? this.inputUnitRender(item.key, ROUGHNESS_HEIGHT_UNIT) : null}
                />}
            </Fragment>}
      </div>
    })
  }

  render() {
    const { text } = this.props;

    return (
      <Fragment>
        <div className='editable-cell-value-wrap'>
          {text}
        </div>
        {this.renderDialog()}
      </Fragment>
    )
  }
}


export default RoughnessPanel;